import { FleetCategory } from '../enums/fleet-category';

export type TrailerCategory = (typeof TRAILER_CATEGORIES)[number];

export const TRAILER_CATEGORIES = [
  FleetCategory.SEMI_TRAILER,
  FleetCategory.TRAILER,
] as const;
